// extracted by mini-css-extract-plugin
export default {"RegisterPage":"RegisterPage_RegisterPage__FxlHc"};